import classNames from 'classnames';
import { FC } from 'react';

interface AdvancedFilterButtonProps {
  value: boolean;
  onToggle: () => void;
}
export const AdvancedFilterButton: FC<AdvancedFilterButtonProps> = ({ value, onToggle }) => {
  return (
    <button
      type="button"
      onClick={onToggle}
      className={classNames('btn btn-flat-secondary btn-xl btn-icon border-start border-opacity-40', {
        active: value,
      })}
      data-e2e="advanced-filters-btn"
    >
      <i className="icon">filter_list</i>
    </button>
  );
};
